import { AppBar, Box, Divider, Toolbar, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";

import { rootPaths } from "../../routes/routePaths";
import Text from "../atoms/Text";
import UnstyledLink from "../atoms/UnstyledLink";
import OmneByFwdIcon from "../icons/branding/OmneByFwdIcon";
import ProfileStack from "../molecules/ProfileStack";

type Props = {
  title: string;
  titleClickPath?: string;
};

const Header = ({ title, titleClickPath = "/" }: Props) => {
  const { t } = useTranslation();

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: "unset",
        backgroundColor: "white",
        color: "black",
        borderRadius: "16px",
        mb: "40px"
      }}
    >
      <Toolbar sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 24px"
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 4, width: "100%", flex: 1 }}>
          <UnstyledLink to={rootPaths.tools}>
            <OmneByFwdIcon />
          </UnstyledLink>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Text variant="title_medium" sx={{ fontWeight: 600, fontSize: "16px", margin: 0 }}>{t("platform.LandingPage_title_Digital_Bridge")}</Text>
            <Typography variant="body_small" sx={{ color: "#859D99", fontSize: "12px", margin: 0 }}>{t("platform.LandingPage_subTitle")}</Typography>
          </Box>
          {/* <Box sx={{ flex: 1, maxWidth: "600px", mx: 4 }}>
            <OutlinedInput
              id="outlined-adornment-weight"
              aria-describedby="outlined-weight-helper-text"
              sx={{
                width: "100%",
                height: "40px",
                backgroundColor: "#f5f5f5",
                borderRadius: "20px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px",
                  fontSize: "14px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ff8c00",
                },
              }}
            />
          </Box> */}
        </Box>
        <Divider orientation="vertical" sx={{ borderColor: "#DBDFE1" }} />
        <Box
          sx={{
            justifySelf: "flex-end",
            paddingLeft: "16px"
          }}
        >
          <ProfileStack />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
